import { SessionExpired } from './auth'

const verifyHttpErro = (err: any) => {
    if (err?.response?.status === 401) {
        SessionExpired()
    }
}

export default verifyHttpErro;